import Vue from "vue";
import VueRouter from "vue-router";
import PolicyCN from "../views/PolicyCN.vue";
import PolicyEN from "../views/PolicyEN.vue";
import CPSCN from "../views/CPSCN.vue";
import CPSEN from "../views/CPSEN.vue";
import HESCN from "../views/HESCN.vue";
import HESEN from "../views/HESEN.vue";
import SolarCN from "../views/SolarCN.vue";
import SolarEN from "../views/SolarEN.vue";
import YaskawaCN from "../views/YaskawaCN.vue";
import YaskawaEN from "../views/YaskawaEN.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/policy_en-US",
  },
  {
    path: "/policy_zh-CN",
    name: "PolicyCN",
    component: PolicyCN,
  },
  {
    path: "/policy_en-US",
    name: "PolicyEN",
    component: PolicyEN,
  },
  {
    path: "/cps_zh-CN",
    name: "CPSCN",
    component: CPSCN,
  },
  {
    path: "/cps_en-US",
    name: "CPSEN",
    component: CPSEN,
  },
  {
    path: "/hes_en-US",
    name: "HESEN",
    component: HESEN,
  },
  {
    path: "/hes_zh-CN",
    name: "HESCN",
    component: HESCN,
  },
  {
    path: "/solar_en-US",
    name: "SolarEN",
    component: SolarEN,
  },
  {
    path: "/solar_zh-CN",
    name: "SolarCN",
    component: SolarCN,
  },
  {
    path: "/yaskawa_en-US",
    name: "YaskawaEN",
    component: YaskawaEN,
  },
  {
    path: "/yaskawa_zh-CN",
    name: "YaskawaCN",
    component: YaskawaCN,
  },
  {
    path: "*",
    redirect: "/policy_en-US",
  },
];

const router = new VueRouter({
  routes,
});

export default router;
